export default "__VITE_ASSET__18f0fb11__"